import * as React from 'react';
import { IconCar16, UIText2, IconWalk16 } from '@cian/ui-kit';
import * as styles from './PikPlusSubway.css';
import { UndergroundIcon } from '../UndergroundIcon';
import { EMovingType } from '../../constants/pikPlus';

interface IPikPlusSubwayProps {
  title?: string | null;
  lineColor?: string | null;
  timeDisplay?: string | null;
  movingType: EMovingType | null;
  regionId: number | null;
}

export function PikPlusSubway({ title, lineColor, regionId, movingType, timeDisplay }: IPikPlusSubwayProps) {
  return (
    <div className={styles['container']} data-testid="pik_plus_subway">
      <span className={styles['subway']}>
        {lineColor && <UndergroundIcon regionId={regionId} lineColor={lineColor} />}
        {title && <span className={styles['title']}>{title}</span>}
      </span>
      {timeDisplay && (
        <div className={styles['subway-from']}>
          {movingType && movingType === EMovingType.Walk ? (
            <IconWalk16 color="white_100" />
          ) : (
            <IconCar16 color="white_100" data-testid="subway_icon_car" />
          )}
          <div className={styles['time']}>
            <UIText2 color="white_100">{timeDisplay}</UIText2>
          </div>
        </div>
      )}
    </div>
  );
}
